import { z } from "zod";

export const triggerAdditionalKeywordFiltersGetSchema = z.object({
  filter_key: z.literal("or_behavior_condition_filter"),
  additional_filter_data: z.strictObject({}),
  allowed_for_predictions: z.literal(false),
  allowed_for_territories: z.literal(false),
  varies_by_app_group: z.literal(false),
  only_for_workflow_step: z.literal(false),
  comparison_key: z.literal("1"),
  display_name: z.literal(""),
  filters: z.array(
    z.object({
      additional_filter_data: z.strictObject({}),
      allowed_for_predictions: z.literal(false),
      allowed_for_territories: z.literal(false),
      comparison_key: z.enum(["1", "2", "10", "17"]),
      display_name: z.literal(""),
      filter_key: z.enum([
        "line_inbound_message_body_filter",
        "whats_app_inbound_message_body_filter",
        "sms_inbound_message_body_filter",
        "whats_app_inbound_message_flow_id_filter",
        "whats_app_inbound_message_contact_share_filter",
      ]),
      only_for_workflow_step: z.literal(false),
      value: z.string(),
      varies_by_app_group: z.literal(false),
    })
  ),
  value: z.null(),
});
